import React from 'react';
import AdminLogin from '../components/AdminLogin';

const AdminLoginPage: React.FC = () => <AdminLogin />;

export default AdminLoginPage;
